import {DashboardSeriesDerivativeType, DashboardSeriesScanClass} from '../../dashboard-new/types/dashboard.types';

/**
 * We want to have labels always shown above the base image.
 */
export const placePriorityByDerivativeType = {
  [DashboardSeriesDerivativeType.Base]: 100,
  [DashboardSeriesDerivativeType.Labeled]: 200,
};

/**
 * The scan types order doesn't really matter as we usually have only one shown for each derivative type.
 * Define weight for each scan type just to keep the consistency.
 */
export const placePriorityByScanType = {
  [DashboardSeriesScanClass.T1Brain]: 1,
  [DashboardSeriesScanClass.T1WholeBody]: 2,
  [DashboardSeriesScanClass.T2]: 3,
  [DashboardSeriesScanClass.Flair]: 4,
  [DashboardSeriesScanClass.Tof]: 5,
  [DashboardSeriesScanClass.Swi]: 6,
};
